/**
 * matchStoreToAttraction
 * Used to match the store to a store/attraction in the storeMappings
 * @param {number} storeKey - The store key of the attraction
 * @param {string} searchTerm - The search term of the attraction
 * @param {array} storeMappings - The array of store mappings
 * @returns {object|undefined} - The store mapping object or a literal 'undefined' if not found
 */
export const matchStoreToAttraction = (storeKey, searchTerm, storeMappings) => {
  return storeMappings.find((store) => {
    if (storeKey === 0 && store.search_terms) {
      return store.search_terms.includes(searchTerm.toLowerCase());
    }
    return store.store_keys?.includes(storeKey.toString());
  });
};

/**
 * matchOfferToAttraction
 * Used to match the offer to a offer/attraction in the offerMappings
 * @param {number} offerKey - The store key of the attraction
 * @param {array} offerMappings - The array of offer mappings
 * @returns {object|undefined} - The store mapping object or a literal 'undefined' if not found
 */
export const matchOfferToAttraction = (offerGroupKey, offerMappings) => {
  return offerMappings.find((offer) => {
    return offer.offer_group_keys?.includes(offerGroupKey.toString());
  });
};
